import { Language, TRANSLATIONS_MAP } from './translationMap';
import {
    I18nFunction,
    I18nOptions,
    i18nRaw as _createI18N,
    I18nRawFunction,
    setI18nLang as _setI18nLang,
} from '@yandex-int/i18n';

type Localizations = {
    [key: string]: I18nRawFunction;
};

const _localizations: Localizations = {};
let _lang: Language;

export async function loadI18N(forceLang?: Language) {
    const lang = forceLang ? forceLang : 'ru';
    if (_localizations[lang] === undefined) {
        for (let _lang in TRANSLATIONS_MAP) {
            const translations = (await TRANSLATIONS_MAP[_lang as Language]()) as unknown as Record<
                string,
                Record<string, string>
            >;
            const keyset = {
                [_lang]: translations[_lang],
            };
            _localizations[_lang] = _createI18N(keyset);
        }
    }
    setLang(lang);
}

export function setLang(lang: Language) {
    _lang = lang;
    _setI18nLang(lang);
}

export function getLang(): Language {
    return _lang;
}

function i18n(key: string, options?: I18nOptions) {
    return _localizations[_lang](key, options).join('');
}

function i18nRaw(key: string, options?: I18nOptions) {
    return _localizations[_lang](key, options);
}

// Дефолтный экспорт нужен для парсера tanker-kit
export default function getI18N<T extends true>(raw: T): I18nRawFunction;
export default function getI18N<T extends false | undefined>(raw?: T): I18nFunction;
export default function getI18N(raw?: boolean) {
    return raw ? i18nRaw : i18n;
}
